// Optik der Pille (Handoff Pille §4): schwarzes Glas, in Hell und Dunkel gleich.
// Nur diese Farben verwenden – Gold-Akzent und iOS-Systemfarben.

import type { Transition } from 'framer-motion';

export const GLAS = {
  hintergrund: 'rgba(10,10,13,0.9)',
  filter: 'blur(30px) saturate(180%)',
  glanz: 'linear-gradient(180deg, rgba(255,255,255,0.09), transparent 38%)',
  schattenZu: '0 8px 30px rgba(0,0,0,0.45), 0 0 0 0.5px rgba(255,255,255,0.12), inset 0 0.5px 0 rgba(255,255,255,0.16)',
  schattenOffen: '0 30px 80px -20px rgba(0,0,0,0.65), 0 0 0 0.5px rgba(255,255,255,0.14), inset 0 0.5px 0 rgba(255,255,255,0.18)',
  backdrop: 'rgba(8,10,16,0.18)',
} as const;

export const FARBE = {
  gold: '#e2c08d',
  goldFlaeche: 'linear-gradient(180deg,#f0d3a3,#c9a063)',
  goldText: '#2a1d0e',
  gruen: '#30d158',
  blau: '#0a84ff',
  orange: '#ff9f0a',
  rot: '#ff453a',
  rotHell: '#ff6961',
  violett: '#bf5af2',
  indigo: '#5e5ce6',
  grau: '#8e8e93',
  text2: 'rgba(235,235,245,0.6)',
  linie: 'rgba(255,255,255,0.1)',
} as const;

/** „rgba“ einer Systemfarbe mit Deckkraft (für Flächen hinter Icons). */
export function getoent(hex: string, alpha: number): string {
  const n = parseInt(hex.slice(1), 16);
  return `rgba(${(n >> 16) & 255},${(n >> 8) & 255},${n & 255},${alpha})`;
}

/** Feder für Breite/Höhe/Radius – entspricht etwa cubic-bezier(.34,1.3,.64,1) in ~460 ms. */
export const FEDER: Transition = { type: 'spring', stiffness: 380, damping: 30, mass: 0.9 };

/** Inhalt blendet beim Zustandswechsel kurz ein (Prototyp isFade .35s). */
export const EINBLENDEN = {
  initial: { opacity: 0, scale: 0.97, filter: 'blur(4px)' },
  animate: { opacity: 1, scale: 1, filter: 'blur(0px)' },
  transition: { duration: 0.35, ease: 'easeOut' },
} as const;
